import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import FacturacionExterna from "../../components/facturacionExterna";
import Layout from "../../components/layout";

interface Props {}

class FacturacionExternaPage extends React.Component<Props> {
  state = {
    classifications: []
  };

  componentDidMount() {}

  render() {
    return (
      <main>
        <Helmet title="Annuities" />
        <Layout>
          <FacturacionExterna />
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FacturacionExternaPage);
